import { memo, useRef } from 'react'
import { Button, ButtonProps } from '@material-ui/core'

import { getPlaybookTypeIcon } from '@guidde-co/shared.playbook-visibility'

import { ShareOnlyDialog, SharePublishDialog } from 'UI/Components'

import { useBoolean } from 'hooks'
import { logToAnalytics, playbookToAnalyticsProps, capitalize } from 'modules'

import { PlaybookType } from 'app/types'

type Props = {
    playbook: PlaybookType
    canShare: boolean
    revalidatePlaybook?: () => void
} & ButtonProps

export const Share = memo(({ playbook, canShare, revalidatePlaybook, ...buttonProps }: Props) => {
    const { isPublished, visibility, isPlaylist, mode } = playbook

    const shareDropdownRef = useRef(null)

    const showShareDialog = useBoolean()

    const target = isPlaylist ? 'playlist' : 'video'

    return (
        <>
            <Button
                ref={shareDropdownRef}
                style={{ height: '32px' }}
                onClick={() => {
                    showShareDialog.setTrue()
                    logToAnalytics(`share_btn_clicked`, {
                        ...playbookToAnalyticsProps(playbook),
                        playbookType: mode
                    })
                }}
                title={`Share ${target}`}
                data-cy="share-button"
                startIcon={getPlaybookTypeIcon(visibility)}
                {...buttonProps}
            >
                Share
            </Button>

            {canShare ? (
                <>
                    {showShareDialog.isTrue && (
                        <SharePublishDialog
                            isOpen={true}
                            onClose={showShareDialog.toggle}
                            onDone={() => revalidatePlaybook?.()}
                            playbook={playbook}
                            title={`Share your ${target}`}
                        />
                    )}
                </>
            ) : (
                <>
                    {showShareDialog.isTrue && (
                        <ShareOnlyDialog
                            isOpen={true}
                            onDone={() => {}}
                            onClose={showShareDialog.setFalse}
                            playbook={playbook}
                            title={`Share your ${target}`}
                            subtitle={`Invite people to view your ${capitalize(target)}`}
                            warning={
                                isPublished ? '' : 'Anyone in your team with this link can view'
                            }
                        />
                    )}
                </>
            )}
        </>
    )
})
